export default "__VITE_ASSET__2cVRbysH__"